import { IkasStorefrontLocalization } from "./localization";
import { IkasStorefrontDomain } from "./domain";
import { IkasStorefrontRouting } from "./routing";
import { IkasStorefrontTheme } from "./theme";
import { IkasStorefontMetaTemplates } from "./meta-templates";

export enum IkasStorefrontStatus {
  WAITING = "WAITING",
  READY = "READY",
}

export type IkasStorefront = {
  id: string;
  name: string;
  status: IkasStorefrontStatus;

  mainStorefrontThemeId: string | null;
  pickUpStockLocationIds: string[] | null;
  emailSettingsId: string | null;
  salesChannelId: string | null;
  fbpId: string | null;
  gtmId: string | null;
  analytics4Id: string | null;
  universalAnalyticsId: string | null;
  tiktokPixelId: string | null;
  token: string | null;
  metaTemplates: IkasStorefontMetaTemplates[] | null;
  robotsTxt: string | null;
  localizations: IkasStorefrontLocalization[];
  routings: IkasStorefrontRouting[];
  domains: IkasStorefrontDomain[];
  themes: IkasStorefrontTheme[];
};
